import { FIELD_SETTINGS } from "./constants"

export default fieldName => {
  try {
    return FIELD_SETTINGS[fieldName]
  } catch (error) {
    return {}
  }
}
